import type { User } from '@/configs/apis/user';
import type { Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
import type { useChatContext } from '@/contexts/chat/context';
import { TagTypes } from '@/components/my-avatar/type';
import MemberItem from '@/components/member-Item';
import Empty from '../empty';
import styles from './index.module.scss';

const Contacts = ({
  users,
  setOpen,
  activeChat,
  createChat,
}: {
  users: User[];
  setOpen: (open: boolean) => void;
  activeChat: (chatId: string) => void;
  createChat: ReturnType<typeof useChatContext>['createChat'];
  chats: Chat[];
}) => {
  return (
    <div className={styles.content}>
      {users.length === 0 && <Empty />}
      {users?.map((user) => {
        return (
          <MemberItem
            className={styles.userItem}
            showCheck={false}
            hoverable
            disabled={!(user.have_user_key && user.have_group_key)}
            name={user.name}
            shortName={user.username}
            avatarProps={{
              src: user.avatar!,
              tagType: !(user.have_user_key && user.have_group_key)
                ? TagTypes.KEYERROR
                : undefined,
              info: user,
            }}
            key={user?.userId}
            onClick={async () => {
              setOpen(false);
              const chat = await createChat({ userId: user.userId });
              if (chat) {
                activeChat(chat.chat_id);
              }
            }}
          ></MemberItem>
        );
      })}
    </div>
  );
};

export default Contacts;
